export function GetRole() {
  const empInfo = JSON.parse(localStorage.getItem("auth_user"));
  return empInfo.role;
}
